import { API_NAME } from '../const'
import API from '@aws-amplify/api'
import { convertKeyNamesToSnakeCase, convertKeyNamesToCamelCase } from '../utils/utils'
import { User } from '../types'
import { UserRegistrationInitialValues, UserEditorInitialValues } from 'utils/formik/initialValues'
import { checkCurrentAuthenticatedUser } from 'utils/currentAuthenticatedUserChecker'

export async function fetchCurrentUser(): Promise<User> {
  try {
    const res = await API.get(API_NAME, `/v2/users/current`, {})
    return convertKeyNamesToCamelCase(res.data)
  } catch (err) {
    console.error(err)
    throw err
  }
}

interface FetchUsersResponce {
  totalCount: number
  users: FetchedUser[]
}

export interface FetchedUser {
  id: number
  userId: string
  userName: string
  cognitoEmail: string
  groupName: string
  createdAt: string
  updatedAt: string
}

export async function fetchUsers(
  currentPage: number,
  rowsPerPage: number
): Promise<FetchUsersResponce> {
  await checkCurrentAuthenticatedUser()
  try {
    const response = await API.get(API_NAME, `/v2/users`, {
      queryStringParameters: {
        currentPage: currentPage,
        rowsPerPage: rowsPerPage,
      },
    })
    return {
      totalCount: response.data['total_count'],
      users: response.data['users'].map((user: FetchedUser) => convertKeyNamesToCamelCase(user))
    }
  } catch (err) {
    console.error(err)
    throw err
  }
}

export const createUser = async (data: UserRegistrationInitialValues): Promise<void> => {
  await checkCurrentAuthenticatedUser()
  await API.post(API_NAME, `/v2/users`, { body: { data: convertKeyNamesToSnakeCase(data) } })
}

export const updateUser = async (
  userId: string | undefined,
  data: UserEditorInitialValues
): Promise<void> => {
  await checkCurrentAuthenticatedUser()
  await API.put(API_NAME, `/v2/users/${userId}`, {
    body: { data: convertKeyNamesToSnakeCase(data) },
  })
}

export const deleteUser = async (userId: string | undefined): Promise<void> => {
  await checkCurrentAuthenticatedUser()
  await API.del(API_NAME, `/v2/users/${userId}`, {})
}
